
<template>

    <main class="page" id="blogPost">

        <!-- Facebook SDK -->
        <div id="fb-root"></div>

        <!-- Blog post -->
        <section class="blog-post">

            <div class="container py-4">

                <article v-if="blog" v-bind:class="{'hidden-content': !displayContent}">

                    <div class="row">

                        <div class="col-12 col-md-8 offset-md-2">

                            <section class="headline text-center">

                                <ul class="list-unstyled">
                                    <li v-for="collection in blog.collections" style="display: inline-block; margin: 0 10px;">
                                        <a :href="'/collection/'+collection.seo.handle" class="text-danger text-uppercase mb-2 d-inline-block">{{collection.title}}</a>
                                    </li>
                                </ul>

                                <h1 class="mb-3 text-uppercase text-primary font-weight-bold">{{ blog.title }}</h1>

                                <div class="row mb-4 justify-content-center">

                                    <div class="col-auto mb-2 mb-md-0 tags" v-if="blog.author">
                                        <i class="fal fa-user"></i> &nbsp;{{ blog.author.first_name + " " + blog.author.last_name }}
                                    </div>
                                    <div class="col-auto" v-if="blog.visible_at">
                                        <i class="fal fa-calendar"></i> &nbsp;{{ sloDate(blog.visible_at) }}
                                    </div>
                                    <div class="col-auto tags" v-if="blog.tags && blog.tags.length > 0">
                                        <i class="fal fa-tags"></i> &nbsp;<span style="display:inline-block;margin-right: 10px;text-transform: lowercase" v-for="tag in blog.tags">{{tag.name}}</span>
                                    </div>
                                </div>

                                <div class="divider-image divider-image-2 mb-5"></div>

                            </section>
                        </div>
                    </div>

                    <div class="row">

                        <div class="col-12 col-md-6 offset-md-3">

                            <section class="blog-content">


                                <!-- Featured image -->
                                <section class="featured-image">

                                    <!-- Main gallery -->
                                    <div class="gallery-wrapper" v-if="blog.template === 'Gallery' && !displayGallerySlide">

                                        <div class="gallery-overlay">

                                            <div class="vertically-aligned">

                                                <ul class="list-unstyled">
                                                    <li v-for="collection in blog.collections" style="display: inline-block; margin: 0 10px;">
                                                        <a :href="'/collection/'+collection.seo.handle" class="text-danger text-uppercase mb-2 d-inline-block">{{collection.title}}</a>
                                                    </li>
                                                </ul>

                                                <h2 class="mb-3 text-uppercase text-primary font-weight-bold">{{ blog.title }}</h2>

                                                <div class="divider-image divider-image mb-5"></div>

                                                <p class="mb-4 justify-content-center text-center">
                                                    {{ blog.excerpt }}
                                                </p>

                                                <a href="javascript:" @click="displayGallerySlide = true" class="btn btn-danger">VIEW THE GALLERY</a>
                                            </div>
                                        </div>

                                        <div class="image-wrapper" v-if="blog.image" :style="'background-image: url('+displayImage(blog.image, 850)+')'"></div>
                                    </div>

                                    <!-- Gallery slide -->
                                    <div class="gallery-slide" v-if="blog.images && blog.template === 'Gallery' && displayGallerySlide">

                                        <div class="row gallery-head">

                                            <div class="col-12 col-sm-4 mb-4 mb-sm-0 text-center text-sm-left">

                                                <ul>
                                                    <li class="text-uppercase">View</li>
                                                    <li>
                                                        <a href="javascript:" @click="galleryView = 'slide'" :class="{'active': galleryView === 'slide'}"><i class="fal fa-image"></i></a>
                                                    </li>
                                                    <li>
                                                        <a href="javascript:" @click="galleryView = 'list'" :class="{'active': galleryView === 'list'}"><i class="fal fa-list"></i></a>
                                                    </li>
                                                </ul>

                                            </div>

                                            <div class="col-12 col-sm-4 mb-5 mb-sm-0">

                                                <div class="row text-center">

                                                    <div class="col-4">
                                                        <div v-show="typeof blog.images[currentSlideImageIndex - 1] !== 'undefined'">
                                                            <a href="javascript:" @click="currentSlideImageIndex--" class="arrow arrow-prev"><img src="/images/blog.arrow.prev.png" class="img-fluid"> </a>
                                                        </div>
                                                    </div>

                                                    <div class="col-4">{{ (currentSlideImageIndex + 1) }} / {{ blog.images.length }}</div>

                                                    <div class="col-4">
                                                        <div v-show="typeof blog.images[currentSlideImageIndex + 1] !== 'undefined'">
                                                            <a href="javascript:" @click="currentSlideImageIndex++" class="arrow arrow-next"><img src="/images/blog.arrow.next.png" class="img-fluid"> </a>
                                                        </div>
                                                    </div>
                                                </div>

                                            </div>

                                            <div class="col-12 col-sm-4 text-center text-sm-right">

                                                <ul>
                                                    <li class="text-uppercase">Share</li>
                                                    <li>
                                                        <a :href="'https://www.facebook.com/sharer/sharer.php?u=' + currentUrl + $route.fullPath + '&amp;title=' + encodeURI(blog.title) + '&amp;description=' + encodeURI(blog.excerpt)"><i class="fab fa-facebook-f"></i></a>
                                                    </li>
                                                    <li>
                                                        <a :href="'http://twitter.com/intent/tweet?status=' + encodeURI(blog.title) + '+' + currentUrl + $route.fullPath"><i class="fab fa-twitter"></i></a>
                                                    </li>
                                                </ul>

                                            </div>
                                        </div>

                                        <div class="row current-slide" v-show="galleryView === 'slide'">

                                            <div class="col">

                                                <a href="javascript:" @click="currentSlideImageIndex--" class="overlay-arrow overlay-left" v-show="typeof blog.images[currentSlideImageIndex - 1] !== 'undefined'"></a>

                                                <img class="img-fluid" :src="displayImage(blog.images[currentSlideImageIndex], 850)">

                                                <a href="javascript:" @click="currentSlideImageIndex++" class="overlay-arrow overlay-right" v-show="typeof blog.images[currentSlideImageIndex + 1] !== 'undefined'"></a>

                                            </div>
                                        </div>

                                        <div class="row" style="padding: 0 25px;" v-show="galleryView && galleryView === 'list'">

                                            <div class="col-3 mb-4" v-for="(image, index) in blog.images">

                                                <small>{{index + 1}} / {{ blog.images.length }}</small>
                                                <a href="javascript:" @click="currentSlideImageIndex = index; galleryView = 'slide'"><img class="current-slide img-fluid" :src="displayImage(image, 300)"></a>
                                            </div>
                                        </div>

                                        <div class="row" v-if="blog.images[currentSlideImageIndex].title || blog.images[currentSlideImageIndex].description || blog.images[currentSlideImageIndex].author">

                                            <div class="col">
                                                <p>
                                                    <strong>{{blog.images[currentSlideImageIndex].author}}</strong> {{ blog.images[currentSlideImageIndex].title }}<br>
                                                    {{ blog.images[currentSlideImageIndex].description }}
                                                </p>
                                            </div>
                                        </div>
                                    </div>

                                    <!-- Cover image -->
                                    <div class="cover-image-wrapper" v-if="(blog.template === 'Gallery' && blog.youtube) || blog.template === 'Default'">

                                        <div class="row">

                                            <div class="col">

                                                <div v-if="blog.youtube">
                                                    <a v-show="!playYoutubeVideo" @click="playYoutubeVideo = true" :href="blog.youtube.embed + '?autoplay=1'" target="iframe_video1">
                                                <span class="vertically-aligned">
                                                    <i class="fab fa-youtube"></i>
                                                </span>
                                                        <img v-if="blog.image" :src="displayImage(blog.image, 850)" class="img-fluid wide-image img-fluid m-auto">
                                                        <img v-else :src="displayImage(blog.youtube.image, 850)" class="img-fluid wide-image img-fluid m-auto">
                                                    </a>
                                                    <iframe v-show="playYoutubeVideo" width="120%" height="500" style="height: 500px;" frameborder="0" autoplay allowfullscreen name="iframe_video1"></iframe>
                                                </div>
                                                <div v-else>
                                                    <img v-if="blog.image" :src="displayImage(blog.image, 850)" class="img-fluid wide-image img-fluid m-auto">
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                </section>


                                <!-- Text -->
                                <section class="custom-text" :class="{'editor-active': edit}">
                                    <froala v-if="edit" :tag="'textarea'" :config="froalaConfig" v-model="blogEditText"></froala>
                                    <div v-else class="text mb-4 mt-4" v-html="blog.text"></div>
                                </section>


                                <!-- Gallery -->
                                <div v-if="blog.images && blog.template !== 'Gallery'" v-show="blog.images.length > 0" class="gallery pswp-gallery mb-4">

                                    <div class="masonry my-gallery" itemscope itemtype="http://schema.org/ImageGallery">

                                        <figure v-for="image in blog.images" class="grid-item" itemprop="associatedMedia" itemscope itemtype="http://schema.org/ImageObject">
                                            <a :href="displayImage(image)" itemprop="contentUrl" :data-size="image.width+'x'+image.height">
                                                <img class="img-fluid" itemprop="thumbnail" :src="displayImage(image, 300)" :alt="image.title">
                                            </a>
                                            <figcaption style="display: none" itemprop="caption description" v-if="image.title || image.author || image.description">
                                                <p v-if="image.title || image.author">
                                                    <strong v-if="image.author">{{ image.author + ', ' }}</strong><span v-if="image.title">{{ image.title }}</span>
                                                </p>
                                                <p v-if="image.description">
                                                    <small>{{ image.description }}</small>
                                                </p>
                                            </figcaption>
                                        </figure>

                                    </div>
                                </div>


                                <!-- Share -->
                                <div class="share">
                                    <div class="row justify-content-center">
                                        <div class="text-uppercase col-auto">
                                            Share
                                        </div>
                                        <div class="col-auto">
                                            <a :href="'https://www.facebook.com/sharer/sharer.php?u=' + currentUrl + $route.fullPath + '&amp;title=' + encodeURI(blog.title) + '&amp;description=' + encodeURI(blog.excerpt)"><i class="fab fa-facebook-f"></i></a>
                                        </div>
                                        <div class="col-auto">
                                            <a :href="'http://twitter.com/intent/tweet?status=' + encodeURI(blog.title) + '+' + currentUrl + $route.fullPath"><i class="fab fa-twitter"></i></a>
                                        </div>
                                    </div>
                                </div><hr>


                                <!-- Navigation -->
                                <div class="blog-nav mb-5">
                                    <div class="row">
                                        <div class="col-6">
                                            <div v-if="navigation.prev">
                                                <a :href="'/blog/' + navigation.prev.uri" :blog="navigation.prev" class="arrow arrow-prev"><img src="/images/blog.arrow.prev.png" class="img-fluid"></a>
                                                <p class="text-uppercase">Previous post</p>
                                                <a :href="'/blog/' + navigation.prev.uri" :blog="navigation.prev" class="text-primary">{{navigation.prev.title}}</a>
                                            </div>
                                        </div>

                                        <div class="col-6 text-right">
                                            <div v-if="navigation.next">
                                                <a :href="'/blog/' + navigation.next.uri" :blog="navigation.next" class="arrow arrow-next"><img src="/images/blog.arrow.next.png" class="img-fluid"></a>
                                                <p class="text-uppercase">Next post</p>
                                                <a :href="'/blog/' + navigation.next.uri" :blog="navigation.next" class="link">{{navigation.next.title}}</a>
                                            </div>
                                        </div>
                                    </div>
                                </div>


                                <!-- Facebook chat -->
                                <div class="facebook-chat">
                                    <div class="fb-comments" data-width="100%" data-mobile="true" data-colorscheme="light" data-numposts="10"></div>
                                </div>


                            </section>

                        </div>
                    </div>

                </article>

                <div class="filtering-overlay" v-show="!displayContent">

                    <div class="col-12 col-sm-10 offset-sm-1">

                        <p class="filtering-posts"><i class="fal fa-spin fa-spinner"></i> &nbsp; Why? Loading, that's why.</p>

                    </div>
                </div>

            </div>
        </section>

        <section class="featured-articles py-5" v-bind:class="{'hidden-content': !displayContent}" v-if="navigation.related && navigation.related.length > 0">

            <div class="container">

                <div class="row mb-4">

                    <div class="col text-center">

                        <h2 class="text-uppercase mb-2">Več dobrega branja</h2>

                        <div class="divider-image"></div>

                    </div>
                </div>

                <div class="row no-gutters slick-slider light">

                    <div class="col-12 col-sm-4" v-for="item in navigation.related">

                        <blog-featured :blog="item"></blog-featured>

                    </div>

                </div>

            </div>
        </section>

        <pswp-node></pswp-node>

    </main>

</template>

<script>
    import VueFroala from 'vue-froala-wysiwyg';
    import Pswp from '../snippets/Pswp.vue';
    import BlogFeatured from '../snippets/blog/Featured.vue';
    import {mapState, mapActions} from 'vuex'
    import {baseSEO} from "../config";

    export default {
        components: {
            "pswp-node": Pswp,
            "blog-featured":  BlogFeatured,
        },

        data () {
            return {
                playYoutubeVideo: false,
                galleryView: 'slide',
                currentUrl: window.location.href,
                edit: false,
                displayContent: false,
                currentSlideImageIndex: 0,
                displayGallerySlide: false,
                froalaConfig: {

                    // Image upload
                    imageUploadParam: "image",
                    imageUploadURL: window.cms + 'blog/uploadFroalaImage/',
                    imageMaxSize: 50 * 1024 * 1024,
                    imageUploadMethod: 'POST',

                    // Video upload
                    videoUploadParam: "video",
                    videoUploadURL: window.cms + 'blog/uploadFroalaVideo/',
                    videoUploadMethod: 'POST',
                    videoMaxSize: 50 * 1024 * 1024,

                    // Video upload
                    fileUploadParam: "file",
                    fileUploadURL: window.cms + 'blog/uploadFroalaFile',
                    fileUploadMethod: 'POST',
                    fileMaxSize: 200 * 1024 * 1024,

                    editorClass: 'text mb-4 mt-4',
                    charCounterCount: false,
                    toolbarInline: true,
                    toolbarButtons: ['undo', 'redo', 'bold', 'italic', 'underline', 'strikeThrough', '|', 'fontSize', 'color', 'paragraphStyle', '|', 'paragraphFormat', 'align', 'formatOL', 'formatUL', 'outdent', 'indent', 'quote', '-', 'insertLink', 'insertImage', 'insertVideo', 'embedly', 'insertFile', 'insertTable', '|', 'specialCharacters', 'insertHR', 'clearFormatting', '|', 'print', 'html'],
                    videoEditButtons: ['videoRemove', 'videoSize'],
                    imageStyles: {
                        wide: 'Wide image',
                        pleft: 'Pull image left',
                        pright: 'Pull image right',
                    },
                    imageEditButtons: ['imageRemove', '|', 'imageLink', 'linkOpen', 'linkEdit', 'linkRemove', 'imageStyle', 'imageSize'],
                    events: {
                        'froalaEditor.image.beforeUpload': function (e, editor) {

                            editor.opts.imageUploadURL = window.cms + 'blog/uploadFroalaImage/' + window.currentBlogId;
                            editor.opts.videoUploadURL = window.cms + 'blog/uploadFroalaVideo/' + window.currentBlogId;
                        },
                        'froalaEditor.image.afterUpload': function (e, editor) {

                            console.log(e);
                        },
                        'froalaEditor.contentChanged': function (e, editor) {

                            clearTimeout(window.editorDebounce);
                            window.editorDebounce = setTimeout(function() {

                                jQuery.ajax({
                                    url: window.cms + "blog/updateUnsavedText/"+window.currentBlogId,
                                    type: "put",
                                    data: {
                                        unsaved_text: editor.html.get()
                                    }
                                }).fail(function (data) {

                                });

                            }, 900);
                        },
                        "froalaEditor.image.error": function(e, editor, error, response) {

                            console.log(error);
                            console.log(response);
                        }
                    }
                },
                blogEditText: "",
                navigation: {
                    next: null,
                    prev: null,
                    related: null
                },
            }
        },

        computed: {

            ...mapState([
                'blog'
            ]),
        },

        methods: {

            ...mapActions([
                'loadBlogPost',
                'loadBanners'
            ]),

            loadBlog: function(id) {

                let handle = this;
                let edit = handle.$route.name === "edit" || handle.getParameterByName("preview");
                let preview = handle.getParameterByName("preview");

                this.loadBlogPost({id, edit, preview}).then(function(data) {

                    window.currentBlogId = data.blog.id;
                    handle.navigation.next = data.next;
                    handle.navigation.prev = data.prev;
                    handle.navigation.related = data.related;

                    if(handle.$route.name === "edit") {

                        handle.edit = true;
                        handle.blogEditText = (data.blog.unsaved_text === null || typeof data.blog.unsaved_text === "undefined" || data.blog.unsaved_text.length === 0 ? data.blog.text : data.blog.unsaved_text);
                    }

                    if(handle.getParameterByName("preview") && data.blog.unsaved_text !== null && data.blog.unsaved_text.length !== 0) {

                        handle.blog.text = data.blog.unsaved_text;
                    }

                    jQuery(document).ready(function() {

                        setTimeout(function() {

                            initMatchHeightPlugin();

                            handle.displayContent = true;

                            initMasonry();
                            initSlickSlider();
                            initPhotoswipeGallery();
                        }, 250);

                        setTimeout(function() {

                            $.fn.matchHeight._update()
                        }, 450);
                    });
                });
            },

            getBanners: function() {

                let handle = this;
                let mainBackgroundImage = document.getElementById("mainBackgroundImage");

                this.loadBanners().then(function(banners) {

                    if(banners.length > 0 && banners[0].image !== null && typeof banners[0].image !== "undefined") {

                        mainBackgroundImage.style.backgroundImage = "url("+handle.displayImage(banners[0].image, 2200)+")";
                    }
                });
            },
        },

        watch: {

            $route (to, from){

                window.scrollTo({top: 0, left: 0, behavior: 'smooth'});

                this.displayContent = false;
                this.loadBlog(this.$route.params.id);
            }
        },

        mounted: function() {

            this.loadBlog(this.$route.params.id);
            window.scrollTo({top: 0, left: 0, behavior: 'smooth'});

            this.getBanners();
        },

        created: function() {

            (function(d, s, id) {
                let js, fjs = d.getElementsByTagName(s)[0];
                if (d.getElementById(id)) return;
                js = d.createElement(s); js.id = id;
                js.src = 'https://connect.facebook.net/en_US/sdk.js#xfbml=1&version=v2.12&appId=1409179075963852&autoLogAppEvents=1';
                fjs.parentNode.insertBefore(js, fjs);
            }(document, 'script', 'facebook-jssdk'));
        },

        metaInfo: function() {

            let handle = this;

            return {

                title: baseSEO.name,
                titleTemplate: '%s' + (handle.blog && handle.blog.seo ? " - " + handle.blog.seo.title : ""),
                meta: [
                    { author : (handle.blog && handle.blog.author ? handle.blog.author.name : baseSEO.author) },
                    { keywords : (handle.blog && handle.blog.seo ? handle.blog.seo.keywords : baseSEO.keywords) },
                    { description : (handle.blog && handle.blog.seo && handle.blog.seo.description ? handle.blog.seo.description.replace(/\n/g, ' ').trim() : baseSEO.description) },

                    // Facebook
                    {property: 'og:title', content:  (handle.blog && handle.blog.seo ? handle.blog.seo.title : baseSEO.title) },
                    {property: 'og:site_name', content: baseSEO.name },
                    {property: 'og:type', content: 'website'},
                    {property: 'og:url', content: (handle.blog ? baseSEO.url + 'blog/' + handle.blog.uri : baseSEO.url) },
                    {property: 'og:image', content: (handle.blog && handle.blog.image ? window.cms + handle.blog.image.display : baseSEO.image) },
                    {property: 'og:description', content: (handle.blog && handle.blog.seo && handle.blog.seo.description ? handle.blog.seo.description.replace(/\n/g, ' ').trim() : baseSEO.description) },

                    // Twitter card
                    {name: 'twitter:card', content: 'summary'},
                    {name: 'twitter:site', content: (handle.blog ? baseSEO.url +  'blog/' + handle.blog.uri : baseSEO.url) },
                    {name: 'twitter:title', content: (handle.blog && handle.blog.seo ? handle.blog.seo.title : baseSEO.title) },
                    {name: 'twitter:description', content: (handle.blog && handle.blog.seo && handle.blog.seo.description ? handle.blog.seo.description.replace(/\n/g, ' ').trim() : baseSEO.description) },
                    {name: 'twitter:image:src', content: (handle.blog && handle.blog.image ? window.cms + handle.blog.image.display : baseSEO.image) },

                    // Google / Schema.org markup:
                    {itemprop: 'name', content: (handle.blog && handle.blog.seo ? handle.blog.seo.title : baseSEO.name) },
                    {itemprop: 'description', content: (handle.blog && handle.blog.seo && handle.blog.seo.description ? handle.blog.seo.description.replace(/\n/g, ' ').trim() : baseSEO.description) },
                    {itemprop: 'image', content: (handle.blog && handle.blog.image ? window.cms + handle.blog.image.display : baseSEO.image) }
                ],
                links: [
                    {rel: 'canonical', href: (handle.blog ? baseSEO.url + 'blog/' + handle.blog.seo.handle : baseSEO.url) }
                ]
            }
        },
    }

</script>

<style lang="scss">


</style>



// WEBPACK FOOTER //
// src/pages/Blog.vue